module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/todo_en_mobile-7e4b730d471ac55e4ff1f20f83f10e1c.webp";